import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { useSnackbarStore } from '../../../shared/stores/snackbarStore';

export const organisationSettingsKeys = {
  all: ['organisation', 'settings'] as const,
};

export function useOrganisationSettings() {
  return useQuery({
    queryKey: organisationSettingsKeys.all,
    queryFn: async ({ signal }) =>
      unwrap(
        await api.portalGateway.GET('/portal/v1/submit-deadline-extension', {
          signal,
        })
      ),
  });
}

export function useSetSubmitDeadlineExtension() {
  const queryClient = useQueryClient();
  const showSnackbar = useSnackbarStore(state => state.showSnackbar);

  return useMutation({
    mutationFn: async (days: number) =>
      unwrap(
        await api.portalGateway.PUT('/portal/v1/submit-deadline-extension', {
          body: { days },
        })
      ),
    onSuccess: (data, days) => {
      queryClient.setQueryData(organisationSettingsKeys.all, data);
      showSnackbar(
        `Extensions now give ${days} ${days === 1 ? 'day' : 'days'} to submit`,
        'success'
      );
    },
  });
}
